import React, {useEffect, useState} from 'react'
import styled from 'styled-components'
import classes from './Loading.module.css'
import Icon from '../../utils/Icon'

const Loading = () => {
  const LoadingContainer = styled.div`
    width: 100%;
    height: 100vh;
    z-index: 1000;
    //background: var(--brand-curent-bg);
    background: #5bb1d8;
    display: block;
    transition: opacity 0.5s ease-in-out;
    opacity: 1;
    position: fixed;
    top: 0;
  `
  return (
    <LoadingContainer>
      <div className="LoadingWrapper">
        <Icon className={`icon-svg--size-64 Main__Spinner ${classes.Main__Spinner}`} name="SpinnerLoading--Static" />
      </div>
    </LoadingContainer>
  )
}

export default Loading
